@if ($isMobile()) {
  @if ($canGoBack()) {
    <tui-app-bar>
      <button
        tuiIconButton
        type="button"
        class="me-4"
        tuiSlot="start"
        routerLink="."
        appearance="transparent"
      >
        <tui-icon
          [style.border-width.rem]="0.25"
          class="white-bg rounded-full h-[34px]! w-[34px]!"
          icon="@tui.arrow-left"
        ></tui-icon>
      </button>
      <section>
        @if ($isRequestPage()) {
          <x-request-form-change-status-button [isMobile]="true" />
        }
      </section>
      <button
        iconStart="@tui.menu"
        appearance="flat"
        [title]="'core.sidebar.main_btn_title' | translate"
        tuiIconButton
        tuiSlot="end"
        (click)="openSidebar()"
      >
        <tui-drawer
          *tuiPopup="isSidebarOpen"
          class="x-sidebar-drawer"
          direction="end"
          [overlay]="true"
          (click)="$event.target === $event.currentTarget && closeSidebar()"
        >
          <h1
            class="font-extrabold text-[20px] x-text-dark-main flex items-center cursor-pointer"
            routerLink="."
          >
            <x-svg-icon
              icon="x-icon::x-keeper-logo"
              class="me-[2px]"
            ></x-svg-icon>
            Outkeep
          </h1>
          <div class="min-h-[calc(100dvh-5rem)] flex flex-col justify-between">
            <x-profile></x-profile>
            <nav>
              @for (
                group of navigationService.menuGroups;
                track group.groupLabel
              ) {
                @if (
                  group.groupLabel &&
                  navigationService.groupHasVisibleItems(group.items)
                ) {
                  <p
                    class="mt-4 mb-1 text-xs font-semibold uppercase tracking-wider opacity-50 x-text-dark-main"
                  >
                    {{ 'core.sidebar.' + group.groupLabel | translate }}
                  </p>
                }
                @for (item of group.items; track item.label) {
                  @if (
                    permissionService.hasPermission$(item.permission) | async
                  ) {
                    <div
                      [class.pl-2]="group.groupLabel"
                      [class.mb-2]="$last"
                      [title]="'core.sidebar.' + item.label | translate"
                    >
                      <button
                        class="mt-2 x-text-dark-main-important flex items-center"
                        [iconStart]="item.icon"
                        [ngClass]="{
                          'font-bold!': navigationService.isRequestsRouteActive(
                            item.link
                          ),
                        }"
                        [routerLink]="item.link"
                        appearance="flat"
                        size="m"
                        tuiLink
                        (click)="closeSidebar()"
                      >
                        <span
                          class="x-font-body-2"
                          [ngClass]="{
                            'font-bold!':
                              navigationService.isRequestsRouteActive(
                                item.link
                              ),
                          }"
                        >
                          {{ 'core.sidebar.' + item.label | translate }}
                        </span>
                      </button>
                    </div>
                  }
                }
              }
            </nav>
            <section class="shrink-0 gap-y-3 flex flex-col mb-5">
              <ng-template [ngTemplateOutlet]="ngContent"></ng-template>
              <x-theme-selector class="shrink-0"></x-theme-selector>
              @if (languageChangeEnabled) {
                <div tuiGroup>
                  <button
                    tuiButton
                    (click)="setRussianLang()"
                    appearance="accent"
                    size="s"
                  >
                    РУССКИЙ
                  </button>
                  <button
                    tuiButton
                    (click)="setEnglishLang()"
                    appearance="accent"
                    size="s"
                  >
                    ENGLISH
                  </button>
                  <button
                    tuiButton
                    (click)="setTurkishLang()"
                    appearance="accent"
                    size="s"
                  >
                    TURKISH
                  </button>
                </div>
              }
              <x-app-version></x-app-version>
            </section>
          </div>
        </tui-drawer>
      </button>
    </tui-app-bar>
  } @else {
    <tui-app-bar>
      <button
        iconStart="@tui.menu"
        appearance="flat"
        [title]="'core.sidebar.main_btn_title' | translate"
        tuiIconButton
        tuiSlot="start"
        (click)="openSidebar()"
      >
        <tui-drawer
          *tuiPopup="isSidebarOpen"
          class="x-sidebar-drawer"
          direction="start"
          [overlay]="true"
          (click)="$event.target === $event.currentTarget && closeSidebar()"
        >
          <h1
            class="font-extrabold text-[20px] x-text-dark-main flex items-center cursor-pointer"
            routerLink="."
          >
            <x-svg-icon
              icon="x-icon::x-keeper-logo"
              class="me-[2px]"
            ></x-svg-icon>
            Outkeep
          </h1>
          <div class="min-h-[calc(100dvh-5rem)] flex flex-col justify-between">
            <x-profile></x-profile>
            <nav>
              @for (
                group of navigationService.menuGroups;
                track group.groupLabel
              ) {
                @if (
                  group.groupLabel &&
                  navigationService.groupHasVisibleItems(group.items)
                ) {
                  <p
                    class="mt-4 mb-1 text-xs font-semibold uppercase tracking-wider opacity-50 x-text-dark-main"
                  >
                    {{ 'core.sidebar.' + group.groupLabel | translate }}
                  </p>
                }
                @for (item of group.items; track item.label) {
                  @if (
                    permissionService.hasPermission$(item.permission) | async
                  ) {
                    <div
                      [class.pl-2]="group.groupLabel"
                      [class.mb-2]="$last"
                      [title]="'core.sidebar.' + item.label | translate"
                    >
                      <button
                        class="mt-2 x-text-dark-main-important flex items-center"
                        [iconStart]="item.icon"
                        [ngClass]="{
                          'font-bold!': navigationService.isRequestsRouteActive(
                            item.link
                          ),
                        }"
                        [routerLink]="item.link"
                        appearance="flat"
                        size="m"
                        tuiLink
                        (click)="closeSidebar()"
                      >
                        <span
                          class="x-font-body-2"
                          [ngClass]="{
                            'font-bold!':
                              navigationService.isRequestsRouteActive(
                                item.link
                              ),
                          }"
                        >
                          {{ 'core.sidebar.' + item.label | translate }}
                        </span>
                      </button>
                    </div>
                  }
                }
              }
            </nav>
            <section class="shrink-0 gap-y-3 mb-5 flex flex-col">
              <ng-template [ngTemplateOutlet]="ngContent"></ng-template>
              <x-theme-selector class="shrink-0"></x-theme-selector>
              @if (languageChangeEnabled) {
                <div tuiGroup>
                  <button
                    tuiButton
                    (click)="setRussianLang()"
                    appearance="accent"
                    size="s"
                  >
                    РУССКИЙ
                  </button>
                  <button
                    tuiButton
                    (click)="setEnglishLang()"
                    appearance="accent"
                    size="s"
                  >
                    ENGLISH
                  </button>
                  <button
                    tuiButton
                    (click)="setTurkishLang()"
                    appearance="accent"
                    size="s"
                  >
                    TURKISH
                  </button>
                </div>
              }
              <x-app-version></x-app-version>
            </section>
          </div>
        </tui-drawer>
      </button>
      <h1 class="x-font-body-2-bold">
        {{ $navbarHeader() }}
      </h1>
      <button
        [iconStart]="
          $mobileRequestsListCompactMode()
            ? 'x-icon::compact-expand'
            : 'x-icon::compact-collapse'
        "
        title="resize"
        appearance="flat"
        tuiIconButton
        tuiSlot="end"
        class="x-icon-svg"
        (click)="toggleMobileRequestsListCompactMode()"
      ></button>
    </tui-app-bar>
  }
} @else {
  <aside class="p-6 flex flex-col justify-between min-h-full">
    <x-profile></x-profile>
    <nav class="basis-auto grow shrink-0 mt-[48px]">
      @for (group of navigationService.menuGroups; track group.groupLabel) {
        @if (
          group.groupLabel &&
          navigationService.groupHasVisibleItems(group.items)
        ) {
          <p
            class="mt-4 mb-1 px-2 text-xs font-semibold uppercase tracking-wider opacity-50 x-text-dark-main"
          >
            {{ 'core.sidebar.' + group.groupLabel | translate }}
          </p>
        }
        @for (item of group.items; track item.label) {
          @if (permissionService.hasPermission$(item.permission) | async) {
            <button
              style="color: var(--tui-text-primary)"
              tuiButton
              appearance="flat"
              size="m"
              [class.ml-2]="group.groupLabel"
              [class.mb-2]="$last"
              [ngClass]="{
                'font-bold!': navigationService.isRequestsRouteActive(
                  item.link
                ),
              }"
              [iconStart]="item.icon"
              [routerLink]="item.link"
              [title]="'core.sidebar.' + item.label | translate"
              (auxclick)="onAuxClick($event, item.link)"
              (click)="onAuxClick($event, item.link)"
            >
              <span
                [ngClass]="{
                  'font-bold!': navigationService.isRequestsRouteActive(
                    item.link
                  ),
                }"
                class="x-text-dark-main x-font-body-2"
              >
                {{ 'core.sidebar.' + item.label | translate }}
              </span>
            </button>
          }
        }
      }
    </nav>
    <section class="shrink-0 gap-y-3 flex flex-col">
      <x-theme-selector class="shrink-0"></x-theme-selector>
      @if (languageChangeEnabled) {
        <div tuiGroup>
          <button
            tuiButton
            (click)="setRussianLang()"
            appearance="accent"
            size="s"
          >
            РУССКИЙ
          </button>
          <button
            tuiButton
            (click)="setEnglishLang()"
            appearance="accent"
            size="s"
          >
            ENGLISH
          </button>
          <button
            tuiButton
            (click)="setTurkishLang()"
            appearance="accent"
            size="s"
          >
            TURKISH
          </button>
        </div>
      }
      <x-app-version></x-app-version>
    </section>
  </aside>
}

<ng-template #ngContent><ng-content></ng-content></ng-template>
